export const previouslyOrderedTimestampSelector = (state: State.GlobalState): string | null => state.previouslyOrdered.timestamp

export const previouslyOrderedDesignConceptIdSelector = (state: State.GlobalState): string | null => state.previouslyOrdered.designConceptId
